export default __webpack_public_path__ + "static/media/downloadIconBlue.45c6482d.svg";